import styled from 'styled-components';
import { motion } from 'motion/react';
import { Link } from 'react-router';
import { media } from '@styles/breakpoints';

export const CardLink = styled(Link)`
  display: block;
  text-decoration: none;
  color: inherit;
  height: 100%;
`;

export const CardWrapper = styled(motion.article)`
  position: relative;
  height: 300px;
  border-radius: ${({ theme }) => theme.radii.xl};
  overflow: hidden;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.navy[800]};

  /* Borda sutil que aparece no hover */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 1px solid rgba(255, 255, 255, 0);
    transition: border-color 0.4s ease;
    z-index: 2;
    pointer-events: none;
  }

  &:hover::before {
    border-color: rgba(0, 168, 240, 0.4);
  }
`;

export const CardBackground = styled(motion.div)<{ $image?: string; $color?: string }>`
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: ${({ theme }) => theme.colors.navy[800]};
  background-image: ${({ $image, $color }) =>
    $image ? `url(${$image})` : ($color ?? 'linear-gradient(135deg, #183C54 0%, #186C9C 100%)')};
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const CardPattern = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: 0.06;
  background-image: radial-gradient(circle at 1px 1px, white 1px, transparent 0);
  background-size: 28px 28px;
`;

export const CardGradient = styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(
    to bottom,
    rgba(6, 18, 28, 0.65) 0%,
    rgba(6, 18, 28, 0.55) 40%,
    rgba(6, 18, 28, 0.85) 100%
  );
`;

export const CardAccentGlow = styled(motion.div)`
  position: absolute;
  bottom: -40px;
  left: -40px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  z-index: 2;
  pointer-events: none;
`;

export const CardContent = styled.div`
  position: absolute;
  inset: 0;
  z-index: 3;

  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => theme.spacing[6]};
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const CardCategory = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: ${({ theme }) => `${theme.spacing[1]} ${theme.spacing[3]}`};
  border-radius: ${({ theme }) => theme.radii.full};
  background-color: rgba(0, 168, 240, 0.18);
  border: 1px solid rgba(0, 168, 240, 0.35);
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.cyan[300]};
`;

export const CardTitle = styled(motion.h3)`
  font-size: ${({ theme }) => theme.fontSizes['2xl']};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: white;
  line-height: ${({ theme }) => theme.lineHeights.snug};
  letter-spacing: ${({ theme }) => theme.letterSpacings.snug};

  ${media.tablet} {
    font-size: ${({ theme }) => theme.fontSizes['3xl']};
  }
`;

export const CardTagline = styled(motion.p)`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.semantic.text.inverseMuted};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  max-width: 36ch;
`;

export const CardFooter = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing[3]};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
`;

export const CardDate = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: ${({ theme }) => theme.letterSpacings.wide};
  text-transform: uppercase;
`;

export const CardArrow = styled(motion.span)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(0, 168, 240, 0.15);
  color: ${({ theme }) => theme.colors.cyan[400]};
  font-size: 1rem;
  line-height: 1;

  transition: background-color 0.4s ease;

  article:hover & {
    background-color: rgba(0, 168, 240, 0.35);
  }
`;
